import { Component, OnInit, inject, signal, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { ProductService } from '../../../shared/service/product.service';
import { VideoGuideData } from '../../../shared/models/video-guide';
import { BaseComponent } from '../../../base/components/base.component';
import { Subject } from 'rxjs';
import { SessionService } from '../../../shared/service/session.service';
import { ClickableDirective } from '../../../shared/directives/clickable.directive';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
    selector: 'app-video-guide',
    imports: [ClickableDirective],
    templateUrl: './video-guide.component.html',
    styleUrl: './video-guide.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoGuideComponent
  extends BaseComponent
  implements OnInit
{
  private readonly productService = inject(ProductService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly sessionService: SessionService = inject(SessionService);
  private readonly location = inject(Location);

  videoGuideData = signal<VideoGuideData[]>([]);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.resolveAllSubscriptions([this.fetchVideoGuide()]);
    this.baseUserService.sessionService.startBnWatch(this.router);
  }

  /**
   * fetch video guide
   */
  private fetchVideoGuide() {
    let returnSubject = new Subject<boolean>();
    this.productService
      .fetchVideoGuide()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (videoGuideResponse) => {
          this.videoGuideData.set(videoGuideResponse?.data || []);
          returnSubject.next(true);
        },
        error: (error) => {
          this.logger.error(error);
          returnSubject.next(true);
        },
        complete: () => {
          returnSubject.complete();
        },
      });
    return returnSubject;
  }

  goBack(): void {
    this.baseUserService.back();
  }
  openLink(item: VideoGuideData) {
    window.open(item.url, '_blank');
  }
}
